import { msg } from "@lingui/core/macro";
import { useLingui } from "@lingui/react";

import { formatPercent } from "@/features/matches";

import { formatBuyTime } from "../../lib/formatBuyTime";
import { BUILD_PHASES } from "../../model/BUILD_PHASES";
import type { HeroItem } from "../../model/HeroBuilds";
import { HERO_ITEM_FOOTER } from "../../model/HERO_ITEM_FOOTER";
import { BuildItems } from "../BuildItems";

const TITLE = msg({ id: "builds.overview.core", message: "Core" });
const HINT = msg({
  id: "builds.overview.core_hint",
  message: "buy in order, more than 60% of players take these",
});

type CoreItemsProps = {
  items: readonly HeroItem[];
  hero: string;
};

// Основа героя (доска «19д»): что берут больше 60 % сильных, по порядку покупки и по фазам
// матча, с минутой под иконкой; доля — в описании предмета.
export const CoreItems = ({ items, hero }: CoreItemsProps) => {
  const { _, i18n } = useLingui();
  const phases = BUILD_PHASES.map((phase, index) => {
    const fromS = BUILD_PHASES[index - 1]?.untilS ?? 0;
    return {
      label: _(phase.label),
      items: items.filter(
        (item) => item.avg_buy_time_s >= fromS && item.avg_buy_time_s < phase.untilS,
      ),
    };
  }).filter((phase) => phase.items.length > 0);
  return (
    <section
      aria-label={_(TITLE)}
      className="flex flex-col gap-3 rounded-xl border border-border-strong bg-surface px-4 py-3.5"
    >
      <div className="flex flex-wrap items-baseline gap-x-2.5 gap-y-1">
        <h4 className="text-base font-semibold">{_(TITLE)}</h4>
        <span className="text-[13px] text-subtle">{_(HINT)}</span>
      </div>
      <div className="flex flex-wrap gap-x-7 gap-y-3.5">
        {phases.map((phase) => (
          <div key={phase.label} className="flex flex-col gap-1.5">
            <span className="text-xs text-subtle">{phase.label}</span>
            <BuildItems
              size={48}
              showPickRate={false}
              items={phase.items.map((item) => ({
                itemId: item.item_id,
                atS: item.avg_buy_time_s,
                footer: _({
                  ...HERO_ITEM_FOOTER,
                  values: {
                    share: formatPercent(item.pick_rate, i18n.locale),
                    hero,
                    time: formatBuyTime(item.avg_buy_time_s),
                  },
                }),
              }))}
            />
          </div>
        ))}
      </div>
    </section>
  );
};
